export const SITE = {
  name:        'Coed y Celyn Hall',
  fullName:    'Coed y Celyn Hall Self-catering Accommodation',
  tagline:     'Your Home in the Heart of Snowdonia',
  description: 'Six beautifully appointed self-catering apartments in a Grade II listed historic hall on the banks of the River Conwy, Betws-y-Coed. 4 Star Visit Wales rated. Personal service from owners Michael & Tracy.',
  phone:       '07821 099595',
  phoneTel:    'tel:+447821099595',
  email:       '',
  owners:      'Michael & Tracy',
  founded:     '2005',
  domain:      'http://www.selfcatering-in-snowdonia.co.uk',
  address: {
    building: 'Coed y Celyn',
    street:   '',
    city:     'Betws-y-Coed',
    county:   'Conwy',
    postcode: 'LL24 0SH',
    country:  'Wales, United Kingdom',
    full:     'Coed y Celyn, Betws-y-Coed, Conwy, LL24 0SH',
    mapsUrl:  'https://www.google.com/maps/search/Coed+y+Celyn+Hall+Betws-y-Coed+LL24+0SH',
  },
  social: {
    twitter:  'https://twitter.com/stayinsnowdonia',
    facebook: 'https://www.facebook.com/pages/Coed-y-Celyn-Hall-Betws-y-Coed-Selfcatering-Accommodation-Snowdonia/113019188819748',
    tripadvisor: 'http://www.tripadvisor.co.uk/Hotel_Review-g186447-d1186769-Reviews-Coed_y_Celyn_Hall-Betws_y_Coed_Snowdonia_National_Park_North_Wales_Wales.html',
  },
  awards: [
    { title: 'Visit Wales 4 Star Self Catering', image: 'system_default_template/publicimage/accommodation_grading_wales_default_4star_.gif' },
    { title: 'Cyclists Welcome', image: 'system_default_template/publicimage/Cyclists-small.jpeg' },
    { title: 'Walkers Welcome', image: 'system_default_template/publicimage/Walkers-small.jpeg' },
  ],
  imageBase:   'http://www.selfcatering-in-snowdonia.co.uk/image/upload/coedycelyn/',
  openAllYear: true,
  capacity:    16,
} as const
